
import OpenAI from 'openai';
import { ChatMessage } from '@/types/chat';
import { WEBSITE_ASSISTANT_PROMPT } from './websiteAssistantPrompt';
import { delay } from './chatUtils';

const MAX_RETRIES = 3;
const RETRY_DELAY_MS = 2000;

export const createWebsiteAssistantMessages = (
  text: string,
  conversationHistory: ChatMessage[] = []
): ChatMessage[] => {
  return [
    {
      role: "system",
      content: WEBSITE_ASSISTANT_PROMPT
    },
    ...conversationHistory,
    {
      role: "user",
      content: text
    }
  ];
};

export const getWebsiteAssistantCompletion = async (
  openai: OpenAI,
  text: string,
  conversationHistory: ChatMessage[] = []
): Promise<string | null> => {
  for (let attempt = 0; attempt < MAX_RETRIES; attempt++) {
    try {
      console.log(`Attempting website assistant completion (attempt ${attempt + 1})`);
      
      const messages = createWebsiteAssistantMessages(text, conversationHistory);

      const completion = await openai.chat.completions.create({
        messages,
        model: "gpt-4o-mini",  // Using a smaller, faster model for UI/usage questions
        temperature: 0.7,
        max_tokens: 500
      });

      const response = completion.choices[0]?.message?.content;
      if (!response) {
        console.log('No response content received');
        continue;
      }

      console.log('Successfully received response from website assistant');
      return response;

    } catch (error) {
      console.error(`Error in attempt ${attempt + 1}:`, error);
      
      if (attempt === MAX_RETRIES - 1) {
        throw new Error("No pudimos procesar tu pregunta. Por favor intenta nuevamente.");
      }

      if (error.status === 429) {
        console.log(`Rate limited. Waiting ${RETRY_DELAY_MS}ms before retry...`);
        await delay(RETRY_DELAY_MS);
        continue;
      }

      throw error;
    }
  }

  return null;
};
